import { ActionBar } from "$components/action-bar/action-bar";
import { useRegisterActionBar } from "$components/action-bar/action-bar-offset";
import type { ActionItem } from "$components/action-bar/action-item";
import { DownloadFileIcon } from "$components/icons";
import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  linkToRegistersAnc,
  linkToRegistersAncDownload,
  linkToRegistersNigeriaDailyOutpatient,
  linkToRegistersNigeriaDailyOutpatientDownload,
  linkToRegistersNigeriaGeneralAttendance,
  linkToRegistersNigeriaGeneralAttendanceDownload,
  linkToRegistersPatient,
  linkToRegistersPatientDownload,
} from "../links";

const REGISTER_TO_DOWNLOAD_MAP: Record<string, string> = {
  [linkToRegistersPatient()]: linkToRegistersPatientDownload(),
  [linkToRegistersAnc()]: linkToRegistersAncDownload(),
  [linkToRegistersNigeriaDailyOutpatient()]:
    linkToRegistersNigeriaDailyOutpatientDownload(),
  [linkToRegistersNigeriaGeneralAttendance()]:
    linkToRegistersNigeriaGeneralAttendanceDownload(),
};

/**
 * Bottom action bar for register pages, carrying the per-register "Download"
 * action (Clinic role only — gated by the caller). Only the registers that
 * have a download view show the bar; the rest render nothing.
 */
export const RegisterActionBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const actionBarRef = useRef<HTMLElement>(null);
  useRegisterActionBar(actionBarRef);

  const link = REGISTER_TO_DOWNLOAD_MAP[location.pathname];

  if (!link) {
    return null;
  }

  const actions: ActionItem[] = [
    {
      id: "register.download",
      defaultMessage: "Download",
      icon: <DownloadFileIcon />,
      onClick: () => navigate(link),
    },
  ];

  return <ActionBar actions={actions} containerRef={actionBarRef} />;
};
